import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_PROVEEDORES_URL } from '../../constants'

//Componentes bootstrap
import { Form, Col } from "react-bootstrap";

//Componentes
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider, PaginationTotalStandalone, PaginationListStandalone } from 'react-bootstrap-table2-paginator';
import ToolkitProvider from 'react-bootstrap-table2-toolkit';
import filterFactory, { textFilter } from 'react-bootstrap-table2-filter';
import { toast } from 'react-toastify';

function SeleccionarBanco(props) {
    const idProveedor = props.children[0];
    const propsBanco = props.children[1];
    const [status, setStatus] = useState('');
    const [error, setError] = useState(false);
    const [listaCuentasBancarias, setListaCuentasBancarias] = useState([]);
    const [listaPorBanco, setListaPorBanco] = useState([]);
    const [banco, setBanco] = useState(propsBanco);
    const [rowSelected, setRowSelected] = useState([]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(getCuentasBancarias, [idProveedor]);//Se actualiza cada que se elige un proveedor diferente    
    useEffect(getListaPorBanco, [banco, listaCuentasBancarias]);//Se actualiza cada que se elige un banco diferente

    function handleBancoChange(e) {
        setBanco(e.target.value);
    }

    function getCuentasBancarias() {
        axios.post(API_PROVEEDORES_URL + 'listBancoCuentas',
            {
                "idProveedor": idProveedor
            }
        ).then((res) => {            
            if (res.data.result.code === 200) {
                setListaCuentasBancarias(res.data.cuentasBancarias);
                if ((banco !== '') && (res.data.cuentasBancarias.length)) {
                    setBanco(res.data.cuentasBancarias[0].nombreBanco);
                }
            } else {
                setError(true);
                setStatus(res.data.result.message);
            }
        }).catch((error) => {
            setError(true);
            setStatus("Error: No se han podido recuperar las cuentas bancarias de este proveedor")
        })
    }

    function cargarSelectBanco() {
        return listaCuentasBancarias.length ? listaCuentasBancarias.map(e => {
            return (<option key={e.id} value={e.nombreBanco}>{e.nombreBanco}</option>)
        }) : 'No existen bancos registrados'
    }

    function getListaPorBanco() {
        let lista;
        lista = listaCuentasBancarias.filter(function (l) {
            return l.nombreBanco === banco;
        })
        setListaPorBanco(lista);
    }

    let handleSizePerPage = ({ page, onSizePerPageChange }, newSizePerPage) => {
        onSizePerPageChange(newSizePerPage, page);
    }

    let handleOnSelect = (row, isSelect) => {
        if (isSelect) {
            setRowSelected(row);
            props.onBancoSelected(row);
        } else {
            toast.warning("Debes seleccionar una cuenta bancaria",{
                position:"top-center",
                autoClose: 4500, 
            });
        }
    }

    let listarCuentasBancarias = () => {
        if (error) {
            return (<div>{status}</div>);
        } else {
            const columns = [{
                dataField: 'id',
                text: 'ID',
                sort: true,
                filter: textFilter({
                    placeholder: 'Buscar...',
                    className: "form-control-sm"
                })
            },
            {
                dataField: 'cuenta',
                text: 'Cuenta',
                sort: true,
                filter: textFilter({
                    placeholder: 'Buscar...',
                    className: "form-control-sm"
                })
            },
            {
                dataField: 'cuentaClabe',
                text: 'Cuenta CLABE',
                sort: true,
                filter: textFilter({
                    placeholder: 'Buscar...',
                    className: "form-control-sm"
                })
            },
            {
                dataField: 'comentario',
                text: 'Comentario',
                sort: true,
                filter: textFilter({
                    placeholder: 'Buscar...',
                    className: "form-control-sm"
                })
            }];

            const selectRow = {
                mode: "radio",
                clickToSelect: true,
                style: { backgroundColor: '#f5f5f580' },
                selectionHeaderRenderer: () => 'X',
                onSelect: handleOnSelect
            };

            function indication() {
                return listaPorBanco[0].lista.length ? "La búsqueda no coincide con ningún criterio" : "No hay registros que mostrar";
            }

            const customTotal = (from, to, size) => (
                <span className="react-bootstrap-table-pagination-total">
                    Mostrando {from} - {to} de {size}
                </span>
            );

            const options = {
                custom: true,
                sizePerPage: 5,
                totalSize: listaPorBanco[0].lista.length,
                paginationTotalRenderer: customTotal
            }

            const contentTable = ({ paginationProps, paginationTableProps }) => (
                <div>
                    <ToolkitProvider
                        keyField='id'
                        data={listaPorBanco[0].lista}
                        columns={columns}
                    >
                        {toolkitprops => (
                            <div className="div-select-banco">
                                <Form.Row className="p-2">
                                    <div className="d-flex flex-row">
                                        <Form.Label column>Mostrar</Form.Label>
                                        <Col>
                                            <Form.Control className="form-control-font-size" size="sm" as="select" onChange={(e) => handleSizePerPage(paginationProps, e.target.value)}>
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="15">15</option>
                                                <option value={listaPorBanco[0].lista.length}>Todos</option>
                                            </Form.Control>
                                        </Col>
                                    </div>
                                    <div className="d-flex flex-row">
                                        <Col>
                                            <PaginationTotalStandalone {...paginationProps} />
                                        </Col>
                                    </div>
                                    <div className="d-flex ml-auto flex-row-reverse">
                                        <Col>
                                            <PaginationListStandalone {...paginationProps} />
                                        </Col>
                                        <Form.Label column>Página</Form.Label>
                                    </div>
                                </Form.Row>
                                <div className="table-responsive table-sm text-center">
                                    <BootstrapTable
                                        id='selectBanco'
                                        selectRow={selectRow}
                                        filter={filterFactory()}
                                        bordered={false}
                                        noDataIndication={indication}
                                        {...paginationTableProps}
                                        {...toolkitprops.baseProps}
                                    />
                                </div>
                            </div>
                        )}
                    </ToolkitProvider>
                </div>
            );

            return <PaginationProvider pagination={paginationFactory(options)}>
                {contentTable}
            </PaginationProvider >
        }
    }

    return (
        <fieldset>
            <Form.Row as={Col}>
                <Form.Group as={Col}>
                    <Form.Label>Banco</Form.Label>
                    <Form.Control size="sm" id="banco" type="text" as="select" required value={banco} onChange={handleBancoChange}>
                        <option default value="">Seleccione banco</option>
                        {cargarSelectBanco()}
                    </Form.Control>
                </Form.Group>
            </Form.Row>
            <Form.Row as={Col}>
                {listaPorBanco.length !== 0 ? listarCuentasBancarias() : " Seleccione un banco para obtener sus cuentas bancarias"}
            </Form.Row>
        </fieldset>
    );
}
export default SeleccionarBanco;